import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <IndexSection />
        <UpdatesSection />
        <CommentsSection />
        <ContactSection />
        <RankingSection />
        <MediaSection />
        <CardsSection />
        <TopicsSection />
        <CarouselSection />
        <AppSection />
        <AboutSection />
        <FaqSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}